import { SET_LOA_DATA, LOA_LIST_FETCHING_INIT } from "./types";
const initialState = {
    loaList: [],
    selectedLOA: null,
    totalRecords: 0,
    page: 1,
    perPage: 10,
    search: "",
    isListLoading: false,
    initialListLoading: true,
    isDetailLoading: false,
    isSubmitting: false,
    isDeleting: false,
    listRefetch: false,
};
export default function loaReducer(state = initialState, action) {
    switch (action.type) {
        case SET_LOA_DATA:
            return {
                ...state,
                ...action.payload,
                // Reset listRefetch flag when data is set
                listRefetch: action.payload.listRefetch !== undefined
                    ? action.payload.listRefetch
                    : false,
            };
        case LOA_LIST_FETCHING_INIT:
            return {
                ...state,
                isListLoading: true,
            };
        default:
            return state;
    }
}
